
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/wordpress-integration",
      function () {
        return require("private-next-pages/signature/wordpress-integration.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/wordpress-integration"])
      });
    }
  